module.exports = __webpack_public_path__ + "static/media/logo.45b62ddb.png";